import { Dialog } from '@spiaggeit/spit-ui'
import { useTranslation } from 'react-i18next'

import { useAppSelector } from '@/hooks/store'
import { appSlice } from '@/store/appSlice'
import { LegendContent } from './LegendContent'

export const LegendDialog = () => {
  const { t } = useTranslation()
  const isKiosk = useAppSelector(appSlice.selectors.isKiosk)

  return (
    <Dialog
      scrollContent
      size={isKiosk ? null : 'sm'}
      title={t('map.legend.title')}
      trigger={
        <button
          className="flex select-none items-center whitespace-nowrap rounded-sm border bg-white px-4 py-2 text-sm font-bold text-primary transition-colors hover:border-gray-300"
          type="button"
        >
          <span className="lg:hidden">{t('map.legend.title')}</span>
          <span className="hidden lg:inline">
            {t('map.legend.showLegendCta')}
          </span>
        </button>
      }
    >
      <div className="p-4">
        <LegendContent />
      </div>
    </Dialog>
  )
}
